import React from 'react';

const CustomChart = () => {
	return (
		<div className="supplier-all-content">
			<div className="supplier-details-section_v2">
				<div className="suplier-profile-desc">
					<div className="accordion" id="accordionExample">
						<div className="card">
							<div
								id="collapseTwo"
								className="collapse"
								aria-labelledby="headingTwo"
								data-parent="#accordionExample"
							>
								<div className="card-body supplier-thumbnail">
									<div className="profile-img">
										<img src="/images/suplier.jpg" alt="jpg" />
									</div>
									<div className="edit-btn">
										<button className="button size32">Edit</button>
									</div>
								</div>
							</div>
							<div className="card-header" id="headingTwo">
								<h2 className="mb-0">
									<button
										className="collapsed-button text-left collapsed"
										type="button"
										data-toggle="collapse"
										data-target="#collapseTwo"
										aria-expanded="false"
										aria-controls="collapseTwo"
									>
										<span className="profile-button">
											<div className="factory-name-des">
												<div className="factory-name">
													<h3 className="weight-600 d-flex">
														{' '}
														<span className="title">
															Sinha knit &amp; Denims Ltd.
														</span>
														<span className="grade-list">
															<span className="factory-grade gradeA font-weight-bold">
																A
															</span>
														</span>
													</h3>
													<span className="location mt-12">
														<img src="/icons/flag.png" alt="flag" />
														<p className="regular-16 font-weight-normal">
															Dhaka,Bangladesh
														</p>
														<div className="link pl-3">
															<span className="regular-14 blue text-decoration-underline">
																Copy link
															</span>
															<span className="regular-14 gray_dark_03">|</span>
															<span className="regular-14 blue">Invite</span>
														</div>
													</span>
												</div>
											</div>
											<span className="vertual-btn_arrow">
												<div className="degree-btn">
													<a href="/images/360.png" target="_blank">
														<img src="/images/360.png" alt={360} />
													</a>
												</div>
												<div className="arrow-down">
													<img
														src="/icons/down-arrow-gray-dark-02.svg"
														alt="arrow"
													/>
												</div>
											</span>
										</span>
									</button>
								</h2>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* info */}
			<div className="capacity-section section-padding">
				<h3 className="suplier-title pb-4 font-weight-bold regular-16">
					QUICK INFO
					<span>
						<button className="blue border-0 medium-14">Edit</button>
					</span>
				</h3>
				<div className="info-items">
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Supplier Type</p>
						<h3 className="title regular-18 weight-600">Garments,Fabric, Accessories </h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Category</p>
						<h3 className="title regular-18 weight-600">knit, Print,Woven</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Price Range</p>
						<h3 className="title regular-18 weight-600">MID</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Contact</p>
						<h3 className="title regular-18 weight-500">Marzan - Sourcing &amp; Design</h3>
						<p className="gray_dark_02 regular-14">01789554877</p>
					</div>
				</div>
				<div className="info-items_bottom mt-3">
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Annual Turnover</p>
						<h3 className="title regular-18 weight-600">$300 Million</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Total Employees</p>
						<h3 className="title regular-18 weight-600">20,000</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Production Line</p>
						<h3 className="title regular-18 weight-600">12</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Supplier status</p>
						<div>
							<span className="status green-3 weight-600">Active</span>
							<span className="status archive weight-600">Archive</span>
						</div>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">
							Last Audit <span className="status red-2 gray_dark_01">Audit Pending</span>
						</p>
						<h3 className="title regular-18 weight-600">12-03-2024</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Additional Information</p>
						<div className="addition-info d-flex align-items-center  pt-1">
							<img src="/icons/pdf.svg" alt="" />
							<p className="regular-12 pl-1">BMW PO/2021/202..</p>
						</div>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14"> Trade License</p>
						<div className="addition-info d-flex align-items-center  pt-1">
							<img src="/icons/pdf.svg" alt="" />
							<p className="regular-12 pl-1">BMW PO/2021/202..</p>
						</div>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Factory License</p>
						<div className="addition-info d-flex align-items-center  pt-1">
							<img src="/icons/pdf.svg" alt="" />
							<p className="regular-12 pl-1">BMW PO/2021/202..</p>
						</div>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">TIN Certificate</p>
						<div className="addition-info d-flex align-items-center  pt-1">
							<img src="/icons/pdf.svg" alt="" />
							<p className="regular-12 pl-1">BMW PO/2021/202..</p>
						</div>
					</div>
				</div>
			</div>
			{/* key */}
			<div className="customers-section section-padding">
				<h3 className="suplier-title pb-4 font-weight-bold regular-16">Key customers</h3>
				<div className="customers-items">
					<div className="single same-padding-box">
						<div className="customer-img">
							<img src="/images/zara.png" alt="box" />
						</div>
						<span className="regular-12 status blue-1 radius">Nominated</span>
					</div>
					<div className="single same-padding-box">
						<div className="customer-img">
							<img src="/images/zara.png" alt="box" />
						</div>
					</div>
					<div className="single same-padding-box">
						<div className="customer-img">
							<img src="/images/zara.png" alt="box" />
						</div>
					</div>
					<div className="single same-padding-box">
						<div className="customer-img">
							<img src="/images/zara.png" alt="box" />
						</div>
					</div>
					<div className="single same-padding-box">
						<div className="customer-img">
							<img src="/images/zara.png" alt="box" />
						</div>
					</div>
					<div className="single same-padding-box">
						<div className="customer-img">
							<img src="/images/jack.png" alt="box" />
						</div>
					</div>
					<div className="single same-padding-box">
						<div className="customer-img">
							<img src="/images/zara.png" alt="box" />
						</div>
					</div>
					<div className="single same-padding-box">
						<div className="customer-img">
							<img src="/images/zara.png" alt="box" />
						</div>
					</div>
					<div className="single same-padding-box">
						<div className="customer-img">
							<img src="/images/jack.png" alt="box" />
						</div>
					</div>
					<div className="single same-padding-box">
						<div className="customer-img">
							<img src="/images/zara.png" alt="box" />
						</div>
					</div>
					<div className="single same-padding-box">
						<div className="customer-img">
							<img src="/images/zara.png" alt="box" />
						</div>
					</div>
					<div className="single same-padding-box">
						<div className="customer-img">
							{/* <img src="/images/jack.png" alt="box"> */}
							<span className="demo-name gray_dark_03 weight-500">MANGO</span>
						</div>
					</div>
				</div>
			</div>
			{/* capacity */}
			<div className="capacity-section section-padding">
				<h3 className="suplier-title pb-4 font-weight-bold regular-16">Production capacity</h3>
				<div className="capacity-items">
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02 font-weight-normal">Sales</p>
						<h3 className="title regular-18 gray_dark_01 weight-500">$87M</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">Knitting</p>
						<h3 className="title regular-18 gray_dark_01">
							16 Ton
							<span className="regular-14 gray_dark_02 font-weight-normal">/Per month</span>
						</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">Dyeing</p>
						<h3 className="title regular-18 gray_dark_01">
							50 Ton
							<span className="regular-14 gray_dark_02 font-weight-normal">/Per month</span>
						</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">Sewing</p>
						<h3 className="title regular-18 gray_dark_01">
							50 Pcs
							<span className="regular-14 gray_dark_02 font-weight-normal">/Per month</span>
						</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">Finishing</p>
						<h3 className="title regular-18 gray_dark_01">
							50 Pcs
							<span className="regular-14 gray_dark_02 font-weight-normal">/Per month</span>
						</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">Washing</p>
						<h3 className="title regular-18 gray_dark_01">
							50 Pcs
							<span className="regular-14 gray_dark_02 font-weight-normal">/Per month</span>
						</h3>
					</div>
				</div>
			</div>
			{/* empty */}
			<div className="capacity-section hover-section empty-section section-padding d-none">
				<div>
					<h3 className="suplier-title text-capitalize mb-0 font-weight-bold regular-16">
						MoM Capacity vs Offer Qty vs Order placement
						<span className="ml-12">
							<button className="blue border-0 medium-14 bg-transparent">Edit</button>
						</span>
					</h3>
				</div>
				<div className="alert alert-secondary text-center" role="alert">
					No result found
				</div>
			</div>
			{/* Realation */}
			<div className="capacity-section hover-section section-padding">
				<div className="capacity-header d-flex justify-content-between">
					<div>
						<h3 className="suplier-title pb-4 font-weight-bold regular-16">
							Relation with Nitex
						</h3>
					</div>
					<div>12-12-12</div>
				</div>
				<div className="capacity-items">
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02 font-weight-normal">Garments</p>
						<h3 className="title regular-18 gray_dark_01">
							50/
							<span className="regular-14 gray_dark_02 font-weight-normal">200 pcs</span>
						</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">Fabric</p>
						<h3 className="title regular-18 gray_dark_01">29 Days</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">Avg sample lead time</p>
						<h3 className="title regular-18 gray_dark_01">29 Days</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">No. of order</p>
						<h3 className="title regular-18 gray_dark_01">45</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">Completed order</p>
						<h3 className="title regular-18 gray_dark_01">13</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">Running order</p>
						<h3 className="title regular-18 gray_dark_01">13</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">Order value</p>
						<h3 className="title regular-18 gray_dark_01">50k</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">Quantity</p>
						<h3 className="title regular-18 gray_dark_01">13</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">No. of style</p>
						<h3 className="title regular-18 gray_dark_01">29</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">No. of PO</p>
						<h3 className="title regular-18 gray_dark_01">90</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">Avg. production lead time</p>
						<h3 className="title regular-18 gray_dark_01">90 Days</h3>
					</div>
					<div className="single same-padding-box">
						<p className="regular-18 gray_dark_02">On time delivery</p>
						<h3 className="title regular-18 gray_dark_01">98%</h3>
					</div>
				</div>
			</div>
			{/* order-chart */}
			<div className="order-section hover-section section-padding">
				<div className="order-chart-top">
					<div className="chart-header mb-4 d-flex justify-content-between align-items-center">
						<div>
							<h3 className="suplier-title text-capitalize mb-0 font-weight-bold regular-16">
								MoM Capacity vs Offer Qty vs Order placement
								<span className="ml-12">
									<button className="blue border-0 medium-14 bg-transparent">Edit</button>
								</span>
							</h3>
						</div>
						<div className="chart-status d-flex justify-content-between align-items-center">
							<div className="perfomence-list">
								<ul className="d-flex">
									<li className="sm-fonts regular-12">
										<span className="rd-bg bg-capecity" />
										Capecity
									</li>
									<li className="sm-fonts regular-12">
										<span className="rd-bg bg-Qty" />
										Offer Qty
									</li>
									<li className="sm-fonts regular-12">
										<span className="rd-bg bg-order" />
										Order Placement
									</li>
								</ul>
							</div>
							<div className="year-status transparent-select">
								<div className="select-component">
									<div
										className="click-box click mb-1"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<p className="regular-14 ">Year</p>
										<img src="/images/chevron_down.svg" alt="" />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="supplier-chart-perfomance">
						<div className="perfomance-summery d-flex justify-content-start">
							<div className="left-row">
								<p className="regular-10 weight-500">50k</p>
								<p className="regular-10 weight-500">40k</p>
								<p className="regular-10 weight-500">30k</p>
								<p className="regular-10 weight-500">20k</p>
								<p className="regular-10 weight-500">10k</p>
								<p className="regular-10 weight-500">0k</p>
							</div>
							<div className="progress-row">
								<div className="all-progress d-flex scroll-x-label">
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Jan, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Feb, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Mar, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Apr, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											May, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Jun, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Jun, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											July, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Aug, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Sep, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Oct, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Nov, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Dec, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Dec, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Dec, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Dec, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Dec, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Dec, 23
										</span>
									</div>
									<div className="single-progress cursor-pointer">
										<div className="d-flex align-items-end">
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar capacity"
													style={{ height: '100%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar Offer-qty"
													style={{ height: '60%' }}
												/>
											</div>
											<div className="child-progress d-flex align-items-end">
												<div
													className="child-bar order-placement"
													style={{ height: '70%' }}
												/>
											</div>
										</div>
										<span className="progress-date regular-10 weight-500 mt-12">
											Dec, 23
										</span>
									</div>
								</div>
								<div className="transparent-grid">
									<div className="transparent-grid-row">
										<div className="transparent-grid-column" />
										<div className="transparent-grid-column" />
										<div className="transparent-grid-column" />
										<div className="transparent-grid-column" />
										<div className="transparent-grid-column" />
										<div className="transparent-grid-column" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* middle-chart */}
				<div className="order-chart-middle">
					<div className="order-chart-box">
						<h3 className="suplier-title pb-4 font-weight-bold regular-16 text-capitalize">
							Total Order
						</h3>
						<div className="m-auto text-center">
							<img src="/images/chart1.png" alt="chart" />
						</div>
					</div>
					<div className="order-chart-box">
						<h3 className="suplier-title pb-4 font-weight-bold regular-16 text-capitalize">
							PO Delivery Ratio
						</h3>
						<div className="m-auto text-center">
							<img src="/images/chart1.png" alt="chart" />
						</div>
					</div>
				</div>
				<div className="order-progress-bottom section-padding">
					<h3 className="suplier-title pb-4 font-weight-bold regular-16 text-capitalize">
						Brand wise order value
					</h3>
					<div className="brand-wise-progress">
						<div className="all-brand-progress">
							<div className="brand-progress-single d-flex align-items-center">
								<div className="brand-name">
									<p className="regular-10 weight-500">Brand Name</p>
								</div>
								<div className="progress progress-square">
									<div
										className="progress-bar"
										role="progressbar"
										aria-valuenow={0}
										aria-valuemin={0}
										aria-valuemax={100}
										style={{ width: '65%' }}
									/>
								</div>
							</div>
							<div className="brand-progress-single d-flex align-items-center">
								<div className="brand-name">
									<p className="regular-10 weight-500">Brand Name</p>
								</div>
								<div className="progress progress-square">
									<div
										className="progress-bar"
										role="progressbar"
										aria-valuenow={0}
										aria-valuemin={0}
										aria-valuemax={100}
										style={{ width: '55%' }}
									/>
								</div>
							</div>
							<div className="brand-progress-single d-flex align-items-center">
								<div className="brand-name">
									<p className="regular-10 weight-500">Brand Name</p>
								</div>
								<div className="progress progress-square">
									<div
										className="progress-bar"
										role="progressbar"
										aria-valuenow={0}
										aria-valuemin={0}
										aria-valuemax={100}
										style={{ width: '75%' }}
									/>
								</div>
							</div>
							<div className="brand-progress-single d-flex align-items-center">
								<div className="brand-name">
									<p className="regular-10 weight-500">Brand Name</p>
								</div>
								<div className="progress progress-square">
									<div
										className="progress-bar"
										role="progressbar"
										aria-valuenow={0}
										aria-valuemin={0}
										aria-valuemax={100}
										style={{ width: '75%' }}
									/>
								</div>
							</div>
							<div className="brand-progress-single d-flex align-items-center">
								<div className="brand-name">
									<p className="regular-10 weight-500">Brand Name</p>
								</div>
								<div className="progress progress-square">
									<div
										className="progress-bar"
										role="progressbar"
										aria-valuenow={0}
										aria-valuemin={0}
										aria-valuemax={100}
										style={{ width: '75%' }}
									/>
								</div>
							</div>
						</div>
						<div className="brands-value">
							<ul className="d-flex align-items-end justify-content-between flex-wrap">
								<li className="regular-10 weight-500">0M</li>
								<li className="regular-10 weight-500">$1m</li>
								<li className="regular-10 weight-500">$2m</li>
								<li className="regular-10 weight-500">$3m</li>
								<li className="regular-10 weight-500">$4m</li>
								<li className="regular-10 weight-500">$5m</li>
								<li className="regular-10 weight-500">$6m</li>
								<li className="regular-10 weight-500">$7m</li>
								<li className="regular-10 weight-500">$8m</li>
								<li className="regular-10 weight-500">$9m</li>
							</ul>
						</div>
					</div>
				</div>
				{/* products */}
				<div className="supplier-product-section section-padding">
					<h3 className="suplier-title pb-4 font-weight-bold regular-16">Key Products</h3>
					<div className="supplier-product-header d-flex justify-content-between">
						<div className="inner-tabs products-tab">
							<ul>
								<li className="active">Garments</li>
								<li>Fabric </li>
								<li>Trims</li>
								<li>Accessories</li>
								<li>11 Styles</li>
							</ul>
						</div>
						<div className="transparent-select d-flex justify-content-between align-items-center">
							<div className="select-component mr-12">
								<div
									className="click-box click mb-1"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<p className="regular-14 ">Nitex Design</p>
									<img src="/images/chevron_down.svg" alt="" />
								</div>
							</div>
							<div className="dropdown">
								<button
									className="border-0 d-flex align-items-center justify-content-between bg-transparent"
									type="button"
									id="add-product"
									data-toggle="dropdown"
									aria-expanded="false"
								>
									<p className="regular-14 gray_dark_02 mr-2">Add</p>
									<img src="/images/chevron_down.svg" alt="arrow" />
								</button>
								<ul
									className="dropdown-menu dropdown-menu-right shadow-lg"
									role="menu"
									aria-labelledby="add-product"
									x-placement="bottom-end"
								>
									<li>
										<button className="border-0 bg-transparent">
											<span className="text-nowrap p-2">
												{' '}
												<img src="/icons/Add-round24.svg" alt="add" /> Product
												parameters
											</span>
										</button>
									</li>
									<li>
										<button className="border-0 bg-transparent">
											<span className="text-nowrap p-2">
												<img src="/icons/Add-round24.svg" alt="add" />
												Style
											</span>
										</button>
									</li>
								</ul>
							</div>
							<div>
								<a href="#" className="regular-16 text-black">
									<span className="devided">|</span> View all
								</a>
							</div>
						</div>
					</div>
					<div className="product-category d-flex">
						<span className="status cyan-1 radius regular-12 mr-2">Tee</span>
						<span className="status cyan-1 radius regular-12 mr-2">Polo</span>
						<span className="status cyan-1 radius regular-12 mr-2">Shirt</span>
						<span className="status cyan-1 radius regular-12 mr-2">Sweater</span>
					</div>
					<div className="supplier-products">
						<div className="single-design-card">
							<div className="card-top">
								<img src="/images/t-shirt-orange.png" alt="card-image" />
							</div>
							<div className="hover-option">
								<div className="dropdown">
									<button
										className="border-0 outline-0"
										type="button"
										id="menu1"
										data-toggle="dropdown"
										aria-expanded="false"
									>
										<img src="/icons/more_vertical.svg" alt="ds" />
									</button>
									<ul
										className="dropdown-menu dropdown-menu-right shadow-lg"
										role="menu"
										aria-labelledby="menu1"
										x-placement="bottom-end"
									>
										<li>
											<span className="text-nowrap pr-5">Copy design link</span>
										</li>
										<li>
											<span className="text-nowrap pr-5">Copy design number</span>
										</li>
										<li>
											<span>Edit basic info</span>
										</li>
										<li>
											<span>Edit design</span>
										</li>
										<li>
											<span>Delete</span>
										</li>
									</ul>
								</div>
							</div>
							<div className="card-content">
								<h3 className="regular-12 weight-500 design-title gray_dark_01 text-uppercase">
									Blue Huddie Long Sleeve
								</h3>
								<ul className="common-list-component mt-1">
									<li className="regular-14 gray_dark_02">M/Slim fit</li>
									<li className="regular-14 gray_dark_02">High rise</li>
									<li className="regular-14 gray_dark_02">US</li>
								</ul>
							</div>
						</div>
						<div className="single-design-card">
							<div className="card-top">
								<img src="/images/t-shirt-orange.png" alt="card-image" />
							</div>
							<div className="hover-option">
								<div className="dropdown">
									<button
										className="border-0 outline-0"
										type="button"
										id="menu1"
										data-toggle="dropdown"
										aria-expanded="false"
									>
										<img src="/icons/more_vertical.svg" alt="ds" />
									</button>
									<ul
										className="dropdown-menu dropdown-menu-right shadow-lg"
										role="menu"
										aria-labelledby="menu1"
										x-placement="bottom-end"
									>
										<li>
											<span className="text-nowrap pr-5">Copy design link</span>
										</li>
										<li>
											<span className="text-nowrap pr-5">Copy design number</span>
										</li>
										<li>
											<span>Edit basic info</span>
										</li>
										<li>
											<span>Edit design</span>
										</li>
										<li>
											<span>Delete</span>
										</li>
									</ul>
								</div>
							</div>
							<div className="card-content">
								<h3 className="regular-12 weight-500 design-title gray_dark_01 text-uppercase">
									Blue Huddie Long Sleeve
								</h3>
								<ul className="common-list-component mt-1">
									<li className="regular-14 gray_dark_02">M/Slim fit</li>
									<li className="regular-14 gray_dark_02">High rise</li>
									<li className="regular-14 gray_dark_02">US</li>
								</ul>
							</div>
						</div>
						<div className="single-design-card">
							<div className="card-top">
								<img src="/images/t-shirt-orange.png" alt="card-image" />
							</div>
							<div className="hover-option">
								<div className="dropdown">
									<button
										className="border-0 outline-0"
										type="button"
										id="menu1"
										data-toggle="dropdown"
										aria-expanded="false"
									>
										<img src="/icons/more_vertical.svg" alt="ds" />
									</button>
									<ul
										className="dropdown-menu dropdown-menu-right shadow-lg"
										role="menu"
										aria-labelledby="menu1"
										x-placement="bottom-end"
									>
										<li>
											<span className="text-nowrap pr-5">Copy design link</span>
										</li>
										<li>
											<span className="text-nowrap pr-5">Copy design number</span>
										</li>
										<li>
											<span>Edit basic info</span>
										</li>
										<li>
											<span>Edit design</span>
										</li>
										<li>
											<span>Delete</span>
										</li>
									</ul>
								</div>
							</div>
							<div className="card-content">
								<h3 className="regular-12 weight-500 design-title gray_dark_01 text-uppercase">
									Blue Huddie Long Sleeve
								</h3>
								<ul className="common-list-component mt-1">
									<li className="regular-14 gray_dark_02">M/Slim fit</li>
									<li className="regular-14 gray_dark_02">High rise</li>
									<li className="regular-14 gray_dark_02">US</li>
								</ul>
							</div>
						</div>
						<div className="single-design-card">
							<div className="card-top">
								<img src="/images/t-shirt-orange.png" alt="card-image" />
							</div>
							<div className="hover-option">
								<div className="dropdown">
									<button
										className="border-0 outline-0"
										type="button"
										id="menu1"
										data-toggle="dropdown"
										aria-expanded="false"
									>
										<img src="/icons/more_vertical.svg" alt="ds" />
									</button>
									<ul
										className="dropdown-menu dropdown-menu-right shadow-lg"
										role="menu"
										aria-labelledby="menu1"
										x-placement="bottom-end"
									>
										<li>
											<span className="text-nowrap pr-5">Copy design link</span>
										</li>
										<li>
											<span className="text-nowrap pr-5">Copy design number</span>
										</li>
										<li>
											<span>Edit basic info</span>
										</li>
										<li>
											<span>Edit design</span>
										</li>
										<li>
											<span>Delete</span>
										</li>
									</ul>
								</div>
							</div>
							<div className="card-content">
								<h3 className="regular-12 weight-500 design-title gray_dark_01 text-uppercase">
									Blue Huddie Long Sleeve
								</h3>
								<ul className="common-list-component mt-1">
									<li className="regular-14 gray_dark_02">M/Slim fit</li>
									<li className="regular-14 gray_dark_02">High rise</li>
									<li className="regular-14 gray_dark_02">US</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* certifiaction */}
			<div className="chertification-section hover-section section-padding">
				<div className=" d-flex justify-content-between align-items-center">
					<div>
						<h3 className="suplier-title pb-4 font-weight-bold regular-16">
							Certifications
							<span className="product_grade">(grade-5)</span>
							<span>
								<button className="border-0 bg-transparent">
									<img src="/icons/info.svg" alt="info" />
								</button>
							</span>
						</h3>
					</div>
					<div className="m-0 search-filter filter-with-animation">
						<div className="with-icon right-icon hidden">
							<input type="text" placeholder="Search" defaultValue />
							<span className="right-icon">
								<img src="/icons/search.png" alt="" />
							</span>
						</div>
					</div>
				</div>
				<div className="certification-items">
					<div className="certification-box same-padding-box d-flex flex-column justify-content-center">
						<div className="crt-img mb-4">
							<img src="/images/certificates-icon.png" alt="box" />
						</div>
						<div className="hover-icon">
							<button className="border-0 bg-transparent">
								<img width="20px" src="/icons/edit-black-20.svg" alt="pencil" />
							</button>
						</div>
						<p className="title gray_dark_01 regular-14">Certificates name</p>
						<p className="regular-12 gray_dark_02">Expired: 12 Apr, 2021</p>
						<div className=" key-tag">
							<span className="regular-12 status red-1 radius">Expired</span>
							<span className="regular-12 status cyan-1 radius">Since 2023</span>
						</div>
					</div>
					<div className="certification-box same-padding-box d-flex flex-column justify-content-center">
						<div className="crt-img mb-4">
							<img src="/images/certificates-icon.png" alt="box" />
						</div>
						<div className="hover-icon">
							<button className="border-0 bg-transparent">
								<img width="20px" src="/icons/edit-black-20.svg" alt="pencil" />
							</button>
						</div>
						<p className="title gray_dark_01 regular-14">Certificates name</p>
						<p className="regular-12 gray_dark_02">Expired: 12 Apr, 2021</p>
					</div>
					<div className="certification-box same-padding-box d-flex flex-column justify-content-center">
						<div className="crt-img mb-4">
							<img src="/images/certificates-icon.png" alt="box" />
						</div>
						<div className="hover-icon">
							<button className="border-0 bg-transparent">
								<img width="20px" src="/icons/edit-black-20.svg" alt="pencil" />
							</button>
						</div>
						<p className="title gray_dark_01 regular-14">Certificates name</p>
						<p className="regular-12 gray_dark_02">Expired: 12 Apr, 2021</p>
					</div>
					<div className="certification-box same-padding-box d-flex flex-column justify-content-center">
						<div className="crt-img mb-4">
							<img src="/images/certificates-icon.png" alt="box" />
						</div>
						<div className="hover-icon">
							<button className="border-0 bg-transparent">
								<img width="20px" src="/icons/edit-black-20.svg" alt="pencil" />
							</button>
						</div>
						<p className="title gray_dark_01 regular-14">Certificates name</p>
						<p className="regular-12 gray_dark_02">Expired: 12 Apr, 2021</p>
					</div>
					<div className="certification-box same-padding-box d-flex flex-column justify-content-center">
						<div className="crt-img mb-4">
							<img src="/images/certificates-icon.png" alt="box" />
						</div>
						<div className="hover-icon">
							<button className="border-0 bg-transparent">
								<img width="20px" src="/icons/edit-black-20.svg" alt="pencil" />
							</button>
						</div>
						<p className="title gray_dark_01 regular-14">Certificates name</p>
						<p className="regular-12 gray_dark_02">Expired: 12 Apr, 2021</p>
					</div>
					<div className="certification-box same-padding-box d-flex flex-column justify-content-center">
						<div className="crt-img mb-4">
							<img src="/images/certificates-icon.png" alt="box" />
						</div>
						<div className="hover-icon">
							<button className="border-0 bg-transparent">
								<img width="20px" src="/icons/edit-black-20.svg" alt="pencil" />
							</button>
						</div>
						<p className="title gray_dark_01 regular-14">Certificates name</p>
						<p className="regular-12 gray_dark_02">Expired: 12 Apr, 2021</p>
					</div>
				</div>
			</div>
			{/* technical */}
			<div className="technical-section section-padding">
				<h3 className="suplier-title pb-4 font-weight-bold regular-16">Technical</h3>
				<div className="technical-items">
					<div className="single same-padding-box text-center">
						<div className="technical-img">
							<img src="/icons/rd.svg" alt="box" />
						</div>
						<h3 className="title regular-18 gray_dark_01 font-weight-normal mt-1">R&amp;D</h3>
					</div>
					<div className="single same-padding-box text-center">
						<div className="technical-img">
							<img src="/icons/lab.svg" alt="box" />
						</div>
						<h3 className="title regular-18 gray_dark_01 font-weight-normal mt-1">Lab</h3>
					</div>
					<div className="single same-padding-box text-center">
						<div className="technical-img">
							<img src="/icons/studio.svg" alt="box" />
						</div>
						<h3 className="title regular-18 gray_dark_01 font-weight-normal mt-1">Studio</h3>
					</div>
					<div className="single same-padding-box text-center">
						<div className="technical-img">
							<img src="/icons/sample.png" alt="box" />
						</div>
						<h3 className="title regular-18 gray_dark_01 font-weight-normal mt-1">Sample</h3>
					</div>
					<div className="single same-padding-box text-center">
						<div className="technical-img">
							<img src="/icons/composite.svg" alt="box" />
						</div>
						<h3 className="title regular-18 gray_dark_01 font-weight-normal mt-1">Composite</h3>
					</div>
					<div className="single same-padding-box text-center">
						<div className="technical-img">
							<img src="/icons/etp.svg" alt="box" />
						</div>
						<h3 className="title regular-18 gray_dark_01 font-weight-normal mt-1">ETP</h3>
					</div>
					<div className="single same-padding-box text-center">
						<div className="technical-img">
							<img src="/icons/etp.svg" alt="box" />
						</div>
						<h3 className="title regular-18 gray_dark_01 font-weight-normal mt-1">WTP</h3>
					</div>
				</div>
			</div>
			{/* safety-info */}
			<div className="safety-info hover-section section-padding">
				<h3 className="suplier-title pb-4 font-weight-bold regular-16">
					Safety Information
					<span className="ml-12">
						<button className="blue border-0 medium-14 bg-transparent">Edit</button>
					</span>
				</h3>
				<div className="info-items">
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Number of Floors</p>
						<h3 className="title regular-18 weight-600">7</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Size of Floor (Sqft.)</p>
						<h3 className="title regular-18 weight-600">20</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Total Space (Sqft.)</p>
						<h3 className="title regular-18 weight-600">40</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Total Areas of Factory Premises (Sqft.)</p>
						<h3 className="title regular-18 weight-600">100</h3>
					</div>
				</div>
				{/* bottom */}
				<div className="saftey-pdf-items info-items mt-3">
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14 pb-1"> Quality Organogram</p>
						<div className="d-flex flex-wrap">
							<div className="addition-info d-flex align-items-center">
								<img src="/icons/pdf.svg" width={20} alt="" />
								<p className="regular-12 pl-1">BMW PO/2021/202..</p>
							</div>
							<div className="addition-info d-flex align-items-center">
								<img src="/icons/pdf.svg" width={20} alt="" />
								<p className="regular-12 pl-1">BMW PO/2021/202..</p>
							</div>
						</div>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14 pb-1">Needle Control Policy</p>
						<div className="d-flex flex-wrap">
							<div className="addition-info d-flex align-items-center">
								<img src="/icons/pdf.svg" width={20} alt="" />
								<p className="regular-12 pl-1">BMW PO/2021/202..</p>
							</div>
							<div className="addition-info d-flex align-items-center">
								<img src="/icons/pdf.svg" width={20} alt="" />
								<p className="regular-12 pl-1">BMW PO/2021/202..</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* other information */}
			<div className="other-information-section">
				<div className="location-section" id="location-section">
					<div className="tabs-header d-flex justify-content-between align-items-center">
						<div className="one-half">
							<h3 className="font-weight-bold regular-16 gray_dark_01 text-uppercase">
								Other Information
							</h3>
						</div>
					</div>
					<div className="all-info-tabs">
						<div className="info-tabs inner-tabs d-flex">
							<ul>
								<li>Location</li>
								<li className="active">Bank info</li>
								<li>Sourcing team</li>
								<li>Supplier rating</li>
								<li>Supplier rating</li>
								<li>Team Management</li>
							</ul>
							<div>
								<span>
									<button className="blue border-0 medium-14 bg-transparent ml-3">
										Edit
									</button>
								</span>
							</div>
						</div>
						{/* location */}
						<div className="row">
							<div className="col-md-6 padding-col">
								<div className="location-details">
									<div className="location-heading">
										<span className="regular-16 gray_dark_01 weight-500">
											Office Location
										</span>
										<img src="/icons/edit-supplier.svg" alt="edit" />
									</div>
									<div className="full-details">
										<div className="info-details d-flex align-items-center">
											<p className="regular-14 gray_dark_02">Country</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14">Bangladesh</p>
										</div>
										<div className="info-details d-flex">
											<p className="regular-14 gray_dark_02">State</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01"> Dhaka</p>
										</div>
										<div className="info-details d-flex">
											<p className="regular-14 gray_dark_02">City </p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01">Dhaka</p>
										</div>
										<div className="info-details  d-flex">
											<p className="regular-14 gray_dark_02">Address</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01">
												JANATA BANK LIMITED, Dilkusha CORPORATE BRANCH Dilkusha
												CORPORATE BRANCH 29 Dilkusha C/A,Dhaka-1000
											</p>
										</div>
										<div className="info-details  d-flex">
											<p className="regular-14 gray_dark_02">Map</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01">
												<a href />
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-6 padding-col">
								<div className="location-details">
									<div className="location-heading">
										<span className="regular-16 gray_dark_01 weight-500">
											Office Location
										</span>
										<img src="/icons/edit-supplier.svg" alt="edit" />
									</div>
									<div className="full-details">
										<div className="info-details d-flex align-items-center">
											<p className="regular-14 gray_dark_02">Country</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14">Bangladesh</p>
										</div>
										<div className="info-details d-flex">
											<p className="regular-14 gray_dark_02">State</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01"> Dhaka</p>
										</div>
										<div className="info-details d-flex">
											<p className="regular-14 gray_dark_02">City </p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01">Dhaka</p>
										</div>
										<div className="info-details  d-flex">
											<p className="regular-14 gray_dark_02">Address</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01">
												JANATA BANK LIMITED, Dilkusha CORPORATE BRANCH Dilkusha
												CORPORATE BRANCH 29 Dilkusha C/A,Dhaka-1000
											</p>
										</div>
										<div className="info-details  d-flex">
											<p className="regular-14 gray_dark_02">Map</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01">
												<a href />
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* bank info */}
						<div className="row">
							<div className="col-md-6 padding-col">
								<div className="location-details bank-details">
									<div className="location-heading">
										<span className="regular-16 gray_dark_01 weight-500">
											JANATA BANK
										</span>
										<img src="/icons/edit-supplier.svg" alt="edit" />
									</div>
									<div className="full-details">
										<div className="info-details d-flex align-items-center">
											<p className="regular-14 gray_dark_02">A/C holder name</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14"> Khurshed Alam</p>
										</div>
										<div className="info-details d-flex align-items-center">
											<p className="regular-14 gray_dark_02">CD A/C NO</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01"> 2010033018038</p>
										</div>
										<div className="info-details d-flex align-items-center">
											<p className="regular-14 gray_dark_02">SWIFT CODE</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01">JANBBDDHDCB</p>
										</div>
										<div className="info-details  d-flex align-items-center">
											<p className="regular-14 gray_dark_02">Address</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01">
												JANATA BANK LIMITED, Dilkusha CORPORATE BRANCH Dilkusha
												CORPORATE BRANCH 29 Dilkusha C/A,Dhaka-1000
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-6 padding-col">
								<div className="location-details bank-details">
									<div className="location-heading">
										<span className="regular-16 gray_dark_01 weight-500">
											JANATA BANK
										</span>
										<img src="/icons/edit-supplier.svg" alt="edit" />
									</div>
									<div className="full-details ">
										<div className="info-details d-flex align-items-center">
											<p className="regular-14 gray_dark_02">A/C holder name</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14"> Khurshed Alam</p>
										</div>
										<div className="info-details d-flex align-items-center">
											<p className="regular-14 gray_dark_02">CD A/C NO</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01"> 2010033018038</p>
										</div>
										<div className="info-details d-flex align-items-center">
											<p className="regular-14 gray_dark_02">SWIFT CODE</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01">JANBBDDHDCB</p>
										</div>
										<div className="info-details d-flex align-items-center">
											<p className="regular-14 gray_dark_02">Address</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14 gray_dark_01">
												JANATA BANK LIMITED, Dilkusha CORPORATE BRANCH Dilkusha
												CORPORATE BRANCH 29 Dilkusha C/A,Dhaka-1000
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* team */}
						<div className="row">
							<div className="col-md-6 padding-col">
								<div className="sourcing-team d-flex align-items-center">
									<div className="img">
										<img src="/images/user.jpg" alt="user" />
									</div>
									<div className="sourcing-content">
										<h3 className="gray_dark_01 regular-14 weight-600">
											Partnership owner
										</h3>
										<p className="gray_dark_02 regular-14">
											Kamruzzaman IRAN (Head of Supply Chain)
										</p>
									</div>
								</div>
							</div>
							<div className="col-md-6 padding-col">
								<div className="sourcing-team d-flex align-items-center">
									<div className="img">
										<img src="/images/user.jpg" alt="user" />
									</div>
									<div className="sourcing-content">
										<h3 className="gray_dark_01 regular-14 weight-600">
											Partnership owner
										</h3>
										<p className="gray_dark_02 regular-14">
											Kamruzzaman IRAN (Head of Supply Chain)
										</p>
									</div>
								</div>
							</div>
						</div>
						{/* contact */}
						<div className="row">
							<div className="col-md-6 padding-col">
								<div className="location-details contact-details">
									<div className="location-heading">
										<span className="regular-16 gray_dark_01 weight-600">
											Mohammad Mizanur Rahman (Product Development Manager)
										</span>
										<img src="/icons/edit-supplier.svg" alt="edit" />
									</div>
									<div className="full-details ">
										<div className="info-details d-flex">
											<p className="regular-14 gray_dark_02">01599900003</p>
										</div>
										<div className="info-details d-flex align-items-center">
											<p className="regular-14 gray_dark_02 website">Website</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14">www.dkgbd.com</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-6 padding-col">
								<div className="location-details contact-details">
									<div className="location-heading">
										<span className="regular-16 gray_dark_01 weight-600">
											Mohammad Mizanur Rahman (Product Development Manager)
										</span>
										<img src="/icons/edit-supplier.svg" alt="edit" />
									</div>
									<div className="full-details ">
										<div className="info-details d-flex">
											<p className="regular-14 gray_dark_02">01599900003</p>
										</div>
										<div className="info-details d-flex align-items-center">
											<p className="regular-14 gray_dark_02 website">Website</p>
											<p className="gray_dark_02">:</p>
											<p className="regular-14">www.dkgbd.com</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* review */}
						<div className="row">
							<div className="col-md-4 padding-col">
								<div className="rating-avarage">
									<div className="rating-title d-flex justify-content-between align-items-center">
										<div className="rating-score">
											<img
												src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
												alt="star"
											/>
											<img
												src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
												alt="star"
											/>
											<img
												src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
												alt="star"
											/>
											<img
												src="https://d1e81913shai1s.cloudfront.net/icons/star-default.svg"
												alt="star"
											/>
											<img
												src="https://d1e81913shai1s.cloudfront.net/icons/star-default.svg"
												alt="star"
											/>
										</div>
										<div className="rating-count">
											<p className="regular-16 weight-600 gray_dark_02">3 Reviews</p>
										</div>
									</div>
									<div className="rating-details">
										<div className="single-one py-1 d-flex justify-content-between align-items-center">
											<p className="regular-16 gray_dark_02">Communication</p>
											<span className="star-review">
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
													alt="star"
												/>
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
													alt="star"
												/>
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
													alt="star"
												/>
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
													alt="star"
												/>
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-default.svg"
													alt="star"
												/>
											</span>
										</div>
										<div className="single-one py-1 d-flex justify-content-between align-items-center">
											<p className="regular-16 gray_dark_02">Support</p>
											<span className="star-review rating-3-half">
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
													alt="star"
												/>
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
													alt="star"
												/>
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
													alt="star"
												/>
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-default.svg"
													alt="star"
												/>
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-default.svg"
													alt="star"
												/>
											</span>
										</div>
										<div className="single-one py-1 d-flex justify-content-between align-items-center">
											<p className="regular-16 gray_dark_02">Transparency</p>
											<span className="star-review rating-3-half">
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
													alt="star"
												/>
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
													alt="star"
												/>
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
													alt="star"
												/>
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-default.svg"
													alt="star"
												/>
												<img
													src="https://d1e81913shai1s.cloudfront.net/icons/star-default.svg"
													alt="star"
												/>
											</span>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-8">
								<div className="right-half">
									<div className="all-commnets">
										<div className="single-comment">
											<div className="profile-photo">
												{/* <img src="/images/user.jpg" alt="profile"> */}
												<span className="regular-16 white rounded-circle">T</span>
											</div>
											<div className="name-designation">
												<h3 className="regular-14 gray_dark_01">
													Imran ahmed{' '}
													<span className="tag gray_dark_01 regular-12 ml-1">
														Project manager
													</span>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/edit-supplier.svg"
														alt="edit"
													/>
												</h3>
											</div>
											<div className="rating-details">
												<span className="star-review rating-4">
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
														alt="star"
													/>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
														alt="star"
													/>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
														alt="star"
													/>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
														alt="star"
													/>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-default.svg"
														alt="star"
													/>
												</span>
											</div>
											<div className="rating-comment">
												<p className="regular-14 weight-500 gray_dark_02">
													Amet minim mollit non deserunt ullamco est sit aliqua
													dolor do amet sint. Velit officia consequat duis enim
													velit mollit. Exercitation veniam consequat sunt nostrud
													amet.
												</p>
											</div>
										</div>
										<div className="single-comment">
											<div className="profile-photo">
												{/* <img src="/images/user.jpg" alt="profile"> */}
												<span className="regular-16 white rounded-circle">T</span>
											</div>
											<div className="name-designation">
												<h3 className="regular-14 gray_dark_01">
													Imran ahmed{' '}
													<span className="tag gray_dark_01 regular-12 ml-1">
														Project manager
													</span>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/edit-supplier.svg"
														alt="edit"
													/>
												</h3>
											</div>
											<div className="rating-details">
												<span className="star-review rating-4">
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
														alt="star"
													/>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
														alt="star"
													/>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
														alt="star"
													/>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
														alt="star"
													/>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-default.svg"
														alt="star"
													/>
												</span>
											</div>
											<div className="rating-comment">
												<p className="regular-14 weight-500 gray_dark_02">
													Amet minim mollit non deserunt ullamco est sit aliqua
													dolor do amet sint. Velit officia consequat duis enim
													velit mollit. Exercitation veniam consequat sunt nostrud
													amet.
												</p>
											</div>
										</div>
										<div className="single-comment">
											<div className="profile-photo">
												<img src="/images/user.jpg" alt="profile" />
												{/* <span class="regular-16 white rounded-circle">T</span> */}
											</div>
											<div className="name-designation">
												<h3 className="regular-14 gray_dark_01">
													Imran ahmed{' '}
													<span className="tag gray_dark_01 regular-12 ml-1">
														Project manager
													</span>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/edit-supplier.svg"
														alt="edit"
													/>
												</h3>
											</div>
											<div className="rating-details">
												<span className="star-review rating-4">
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
														alt="star"
													/>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
														alt="star"
													/>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
														alt="star"
													/>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-filled.svg"
														alt="star"
													/>
													<img
														src="https://d1e81913shai1s.cloudfront.net/icons/star-default.svg"
														alt="star"
													/>
												</span>
											</div>
											<div className="rating-comment">
												<p className="regular-14 weight-500 gray_dark_02">
													Amet minim mollit non deserunt ullamco est sit aliqua
													dolor do amet sint. Velit officia consequat duis enim
													velit mollit. Exercitation veniam consequat sunt nostrud
													amet.
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* Team Management */}
						<div className="row">
							<div className="col-md-12">
								<div className="team-managment ">
									<div className="managment-head d-flex justify-content-between align-items-center">
										<p className="gray_dark_02 regular-12">Team Member</p>
										<button className="button outline">
											<img src="/icons/add-round-white24.svg" alt="delete" />
											<span className="ml-1 regular-12 gray_dark_01">Add Member</span>
										</button>
									</div>
									<table className="table team-managmet-table with-border hover">
										<thead>
											<tr>
												<th className="weight-500 regular-12">SL</th>
												<th className="weight-500 regular-12">Team Member</th>
												<th className="weight-500 regular-12">Phone Number</th>
												<th className="weight-500 regular-12">Email</th>
												<th className="weight-500 regular-12">Role</th>
												<th className="weight-500 regular-12">Action</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>1</td>
												<td>e.g. Mr. Rahman</td>
												<td>+880 XXX XXXX XXX</td>
												<td>e.g. example@gmail.com</td>
												<td>Admin</td>
												<td>
													<div className="option">
														<div className="dropdown">
															<button
																className="btn btn-default dropdown-toggle"
																type="button"
																id="menu1"
																data-toggle="dropdown"
																aria-expanded="false"
															>
																<img
																	src="/icons/more_icon.svg"
																	alt="delete"
																/>
															</button>
															<ul
																className="dropdown-menu dropdown-menu-right shadow-lg"
																role="menu"
																aria-labelledby="menu1"
																x-placement="bottom-end"
															>
																<li
																	role="presentation"
																	className="px-4 pb-3 pt-3"
																>
																	<a
																		role="menuitem"
																		tabIndex={-1}
																		className="font-weight-normal  text-black"
																		href="/invoices/edit/10052"
																	>
																		Deactivate
																	</a>
																</li>
																<li role="presentation" className="px-4 pb-3">
																	<a
																		role="menuitem"
																		tabIndex={-1}
																		className="font-weight-normal  text-black"
																		href
																	>
																		Activate
																	</a>
																</li>
															</ul>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>1</td>
												<td>e.g. Mr. Rahman</td>
												<td>+880 XXX XXXX XXX</td>
												<td>e.g. example@gmail.com</td>
												<td>Admin</td>
												<td>
													<div className="option">
														<div className="dropdown">
															<button
																className="btn btn-default dropdown-toggle"
																type="button"
																id="menu1"
																data-toggle="dropdown"
																aria-expanded="false"
															>
																<img
																	src="/icons/more_icon.svg"
																	alt="delete"
																/>
															</button>
															<ul
																className="dropdown-menu dropdown-menu-right shadow-lg"
																role="menu"
																aria-labelledby="menu1"
																x-placement="bottom-end"
															>
																<li
																	role="presentation"
																	className="px-4 pb-3 pt-3"
																>
																	<a
																		role="menuitem"
																		tabIndex={-1}
																		className="font-weight-normal  text-black"
																		href="/invoices/edit/10052"
																	>
																		Deactivate
																	</a>
																</li>
																<li role="presentation" className="px-4 pb-3">
																	<a
																		role="menuitem"
																		tabIndex={-1}
																		className="font-weight-normal  text-black"
																		href
																	>
																		Activate
																	</a>
																</li>
															</ul>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
									<div className="empity-button text-center">
										<p className="pb-2 gray_dark_03 weight-500 regular-16">
											No member found
										</p>
										<button className="button outline">
											<img src="/icons/add-round-white24.svg" alt="delete" />
											<span className="ml-1 regular-12 gray_dark_01">Add Member</span>
										</button>
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="additional-information w-100">
								<div className="additional-info-items">
									<div className="info-single">
										<p className="gray_dark_01 regular-14 weight-600">Bond License</p>
										<div className="addition-info d-flex align-items-center  pt-1">
											<img src="/icons/pdf.svg" alt="" />
											<p className="regular-12 pl-1">BMW PO/2021/202..</p>
										</div>
									</div>
									<div className="info-single">
										<p className="gray_dark_01 regular-14 weight-600">Bond License</p>
										<div className="addition-info d-flex align-items-center  pt-1">
											<img src="/icons/pdf.svg" alt="" />
											<p className="regular-12 pl-1">BMW PO/2021/202..</p>
										</div>
									</div>
									<div className="info-single">
										<p className="gray_dark_01 regular-14 weight-600">Bond License</p>
										<div className="addition-info d-flex align-items-center  pt-1">
											<img src="/icons/pdf.svg" alt="" />
											<p className="regular-12 pl-1">BMW PO/2021/202..</p>
										</div>
									</div>
									<div className="info-single">
										<p className="gray_dark_01 regular-14 weight-600">Bond License</p>
										<div className="addition-info d-flex align-items-center  pt-1">
											<img src="/icons/pdf.svg" alt="" />
											<p className="regular-12 pl-1">BMW PO/2021/202..</p>
										</div>
									</div>
									<div className="info-single">
										<p className="gray_dark_01 regular-14 weight-600">Bond License</p>
										<div className="addition-info d-flex align-items-center  pt-1">
											<img src="/icons/pdf.svg" alt="" />
											<p className="regular-12 pl-1">BMW PO/2021/202..</p>
										</div>
									</div>
									<div className="info-single">
										<p className="gray_dark_01 regular-14 weight-600">Bond License</p>
										<div className="addition-info d-flex align-items-center  pt-1">
											<img src="/icons/pdf.svg" alt="" />
											<p className="regular-12 pl-1">BMW PO/2021/202..</p>
										</div>
									</div>
									<div className="info-single">
										<p className="gray_dark_01 regular-14 weight-600">Bond License</p>
										<div className="addition-info d-flex align-items-center  pt-1">
											<img src="/icons/pdf.svg" alt="" />
											<p className="regular-12 pl-1">BMW PO/2021/202..</p>
										</div>
									</div>
									<div className="info-single">
										<p className="gray_dark_01 regular-14 weight-600">Bond License</p>
										<div className="addition-info d-flex align-items-center  pt-1">
											<img src="/icons/pdf.svg" alt="" />
											<p className="regular-12 pl-1">BMW PO/2021/202..</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CustomChart;
